// PC/Mobile 共通
import Rails from 'rails-ujs';
import * as ActiveStorage from 'activestorage';
import '@fortawesome/fontawesome-free/js/all';
import '@fortawesome/fontawesome-free/css/all';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import flatpickr from 'flatpickr';
import { Japanese } from 'flatpickr/dist/l10n/ja';
import Choices from 'choices.js/assets/scripts/dist/choices';
import swal from 'sweetalert2/dist/sweetalert2.all';
import tippy from 'tippy.js';
import 'whatwg-fetch'; // TODO: 消したい

export function start() {
  require.context('../images', true, /\.(png|jpg|jpeg|svg|gif)$/);

  // Add all icons to the library so you can use it in your page
  library.add(fas, far, fab);

  // ------- ↓confirmダイアログ↓ --------------//
  // グロバルアラートダイアログ
  window.showAlertDialog = (message) => {
    swal({
      title: message,
      confirmButtonText: 'ＯＫ',
    });
    if (window.refreshDocumentRemoteElements) {
      window.refreshDocumentRemoteElements();
    }
  };

  // ボタン確認後
  const confirmed = (element, result) => {
    if (result) {
      // User clicked confirm button
      let message = element.getAttribute('data-confirm-swal');
      element.removeAttribute('data-confirm-swal');
      element.click();
      element.setAttribute('data-confirm-swal', message);
    }
  };

  // 確認ダイアログ表示
  const showConfirmationDialog = (element) => {
    const message = element.getAttribute('data-confirm-swal');
    const vaildCheck = element.getAttribute('data-valid-swal');
    if (vaildCheck === 'true' && typeof validFunc === 'function') {
      // バリデーション関数実行
      let validateResult = validFunc();
      if (validateResult.result === true) {
        // 正常
        confirmed(element, true);
      } else if (validateResult.messageType === 'alert') {
        // アラートダイアログ
        swal({
          title: validateResult.message,
          confirmButtonText: 'ＯＫ',
        }).then(result => confirmed(element, false));
      } else {
        // 確認ダイアログ
        swal({
          title: validateResult.message || 'よろしいですか？',
          showCancelButton: true,
          cancelButtonText: 'キャンセル',
          confirmButtonText: 'ＯＫ',
          focusCancel: true,
          reverseButtons: true,
        }).then(result => confirmed(element, result.value));
      }
    } else {
      // バリデーション関数なし
      swal({
        title: message || 'よろしいですか？',
        showCancelButton: true,
        cancelButtonText: 'キャンセル',
        confirmButtonText: 'ＯＫ',
        focusCancel: true,
        reverseButtons: true,
      }).then(result => confirmed(element, result.value));
    }
  };
  // 確認メッセージ設定有無
  const allowAction = (element) => {
    if (element.getAttribute('data-confirm-swal') === null) {
      return true;
    }

    showConfirmationDialog(element);
    if (window.refreshDocumentRemoteElements) {
      window.refreshDocumentRemoteElements();
    }
    return false;
  };
  // 確認ハンドル
  function handleConfirm(event) {
    if (!allowAction(this)) {
      Rails.stopEverything(event);
    }
  }
  // 確認要素初期化
  Rails.delegate(document, 'input[data-confirm-swal], button[data-confirm-swal], a[data-confirm-swal]', 'click', handleConfirm);
  // ------- ↑confirmダイアログ↑ --------------//

  Rails.start();
  ActiveStorage.start();
  window.Rails = Rails;
}

document.addEventListener('DOMContentLoaded', () => {
  // DatePicker
  flatpickr('.use-calendar', { dateFormat: 'Y/m/d', locale: Japanese });
  // TimePicker
  flatpickr('.use-hour-minute', { enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true, wrap: true, locale: Japanese });

  // Choices.js(SelectBox)
  const $selectElements = Array.prototype.slice.call(document.querySelectorAll('.use-choices'), 0);
  if ($selectElements.length > 0) {
    $selectElements.forEach( $el => {
      let removeItemButton = $el.getAttribute('data-remove-item-button') === 'true' ? true : false;
      new Choices($el, {
        noResultsText:  '検索結果が見つかりません',
        noChoicesText:  '選択肢がありません',
        itemSelectText: 'クリックして選択',
        searchResultLimit: 999,
        silent: true,
        searchFields: ['label'],
        fuseOptions: {
          include: 'score',
          threshold: 0.1,
          tokenize: true,
          matchAllTokens: true,
          shouldSort: true
        },
        removeItemButton: removeItemButton
      });
    });
  }

  // file field
  const $fileFields = document.getElementsByClassName('attach-file-input');
  if ($fileFields.length > 0) {
    [].forEach.call($fileFields, field => {
      field.addEventListener('change', () => {
        document.getElementById(field.dataset.name).textContent = Array.from(field.files).map(f => f.name).join(', ');
      });
    })
  }

  // clear
  const $searchForms = document.getElementsByClassName('search_form');
  if ($searchForms.length > 0) {
    [].forEach.call($searchForms, form => {
      const $clear = form.querySelectorAll('.is-clear')[0];
      if (!$clear) { return }
      const clearInputs = function() {
        [].forEach.call(form.getElementsByTagName('input'), input => {
          if (input.dataset.skipClear) { return; }
          if (input.type === 'hidden') { return; }
          if (input.type === 'checkbox') {
            input.checked = false;  
          } else if (input.type === 'radio' || input.type === 'button') {
            return;
          } else {
            input.value = '';
          }
        });
        [].forEach.call(form.getElementsByTagName('select'), select => {
          if (select.dataset.skipClear) { return; }
          select.selectedIndex = 0;
          select.dispatchEvent(new Event('change'));
        });
      };
      $clear.addEventListener('click', clearInputs);
    });
  }

  // tooltip
  tippy('.tippy', {
    placement: 'bottom',
    interactive: true,
    content(reference) {
      return document.getElementById(reference.getAttribute('data-template'));
    }
  });

  // 店舗選択候補絞り込みボタン
  const $storeOptionSearchButtons = Array.prototype.slice.call(document.querySelectorAll('.store-select-option-search'), 0);
  if ($storeOptionSearchButtons.length > 0) {
    $storeOptionSearchButtons.forEach( $el => {
      $el.addEventListener('click', function () {
        let $targetSelect = document.getElementById($el.dataset.target);
        let $keywordInput = document.getElementById($el.dataset.keyword);
        let $help = document.getElementById($el.dataset.help);
        let store_ids = [];
        let urlParams = [];
        let url;

        Array.prototype.slice.call($targetSelect.children, 0).forEach(function(option){
          if (option.selected) {
            urlParams.push("store_ids[]=" + option.value);
            store_ids.push(option.value);
          }
        });
        urlParams.push("keyword=" + $keywordInput.value);
        urlParams.push("sales_flag=" + $el.dataset.salesFlag);
        url = "/admin/users/stores?" + urlParams.join('&');
        url = encodeURI(url);
        fetch(
          url, 
          {
            credentials: 'same-origin',
            headers: {
              'Accept':       'application/json',
              'X-CSRF-Token': document.head.querySelector('[name=csrf-token]').content
            },
            method: 'GET'
          }
        )
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw Error('店舗データを取得できません。');
          }
        })
        .then((data) => {
          let optionsLength = $targetSelect.children.length;
          for(var i=optionsLength; i>0; i--){
            if ($targetSelect.children[i-1].value !== '') {
              $targetSelect.removeChild($targetSelect.children[i-1]);
            }
          }
          JSON.parse(data.stores).forEach(function(r, i, stores){
            let op = document.createElement("option");
            op.value = $el.dataset.salesFlag.toLowerCase() === 'true' ? r.store_code : r.id;
            op.text = r.name;
            if (store_ids.indexOf(op.value) >= 0) {
              op.selected = true;
            }
            $targetSelect.appendChild(op);
          });
          $targetSelect.focus();
          $help.classList.remove('is-hidden');
        })
        .catch((error) => {
          // エラー表示
          showAlertDialog(error.toString());
        });
      });
    });
  }

  // 店舗選択変更イベント
  const $storeSelectInputs = Array.prototype.slice.call(document.querySelectorAll('.store-select-target-input'), 0);
  if ($storeSelectInputs.length > 0) {
    $storeSelectInputs.forEach( $el => {
      $el.addEventListener('change', function () {
        let $help = document.getElementById($el.id + "_help");
        $help.classList.add('is-hidden');
      });
    });
  }

  // フラッシュメッセージ制御
  let $flashDeleteButtons = Array.prototype.slice.call(document.querySelectorAll('.notification > button.delete'), 0);
  if ($flashDeleteButtons.length > 0) {
    $flashDeleteButtons.forEach( function($el) {
      $el.addEventListener('click', function() {
        $el.parentElement.remove();
      });
      setTimeout((function($el) {
        return function() {
          $el.parentElement.remove();
        };
      })($el), 3000);
    });
  }

  // アップロード前にファイルのサイズをチェックする。
  window.addEventListener('click', e => {
    if (e.target.classList.contains('file-size-check')){
      let $fileInputs = Array.prototype.slice.call(document.querySelectorAll("input[type='file']"), 0);
      if ($fileInputs.length > 0) {
        [].some.call($fileInputs, input => {
          let hasAlert = false;
          if (input.files.length > 0) {
            [].some.call(input.files, file => {
              if (file.size > 104857600) {
                e.preventDefault();
                e.stopPropagation();
                hasAlert = true;
                showAlertDialog("ファイル(" + file.name + ")サイズが大きすぎます。100MB以下にしてください。");
                return true;
              }
            });
          }
          if (hasAlert) return true;
        });
      }
    }
  },true);
});

window.moveTo = (query) => {
  location.hash = '';
  location.hash = query;

  let scrollContent = document.querySelector('.snap-content');
  if (scrollContent) {
    scrollContent.scrollTop = scrollContent.scrollTop - 64;
  } else {
    scrollContent = document.querySelector('html');
    scrollContent.scrollTop = scrollContent.scrollTop - 96;
  }
}

window.moveToTop = () => {
  window.moveTo("top_element_for_xhr");
}

window.friendApply = (element) => {
  let url = '/user/friends/apply?friend_id=' + element.dataset.userId;
  fetch(url, {
    credentials: 'same-origin',
    headers: {
      'Accept':       'text/html',
      'X-CSRF-Token': document.head.querySelector('[name=csrf-token]').content
    },
    method: 'GET'
  }).catch(error => console.error('Error:', error));
  element.parentNode.removeChild(element);
};

window.triggerEvent = (element, event) => {
   if (document.createEvent) {
       // IE以外
       var evt = document.createEvent("HTMLEvents");
       evt.initEvent(event, true, true ); // event type, bubbling, cancelable
       return element.dispatchEvent(evt);
   } else {
       // IE
       var evt = document.createEventObject();
       return element.fireEvent("on"+event, evt)
   }
}
